// In-App Browser Detector & Blocker
(function() {
  'use strict';

  function isInAppBrowser() {
    const ua = navigator.userAgent || '';
    const checks = {
      instagram: /Instagram/i.test(ua),
      facebook: /FBAN|FBAV|FB_IAB/i.test(ua),
      tiktok: /TikTok/i.test(ua),
      snapchat: /Snapchat/i.test(ua),
      twitter: /Twitter|TWITTERRIFIC/i.test(ua),
      pinterest: /Pinterest/i.test(ua),
      linkedin: /LinkedInApp/i.test(ua),
      telegram: /Telegram/i.test(ua),
      whatsapp: /WhatsApp/i.test(ua),
      wechat: /MicroMessenger/i.test(ua)
    };
    return Object.values(checks).some(v => v);
  }

  function showBlocker() {
    if (!isInAppBrowser()) {
      return;
    }

    const blocker = document.createElement('div');
    blocker.id = 'inapp-browser-blocker';
    blocker.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 999999;
      padding: 20px;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    `;

    const currentUrl = window.location.href;

    blocker.innerHTML = `
      <div style="
        background: white;
        border-radius: 20px;
        padding: 40px 30px;
        text-align: center;
        max-width: 400px;
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
      ">
        <div style="font-size: 60px; margin-bottom: 20px;">📱</div>
        <h1 style="font-size: 28px; color: #222; margin-bottom: 15px; font-weight: 700;">
          בואו נפתח בדפדפן
        </h1>
        <p style="font-size: 16px; color: #666; line-height: 1.6; margin-bottom: 30px;">
          אתה כרגע בדפדפן משולב של אפליקציה. כדי לתמוך בחוויה הטובה ביותר, אנא פתח בדפדפן הרגיל שלך.
        </p>
        <button id="inapp-open-btn" style="
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          padding: 16px 40px;
          border-radius: 50px;
          border: none;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          width: 100%;
          max-width: 300px;
          margin-bottom: 15px;
        ">
          פתח בדפדפן
        </button>
  <p style="
          color: #999;
          font-size: 13px;
          margin-top: 15px;
          line-height: 1.5;
        ">
          או בחר "Open in Browser"<br>מתפריט האפליקציה
        </p>
      </div>
    `;

    document.body.appendChild(blocker);
    document.body.style.overflow = 'hidden';

    const button = document.getElementById('inapp-open-btn');
    if (button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        // Try multiple methods to open in browser
        const ua = navigator.userAgent;
        
        if (/Android/i.test(ua)) {
          // Android - try intent://
          try {
            window.location = 'intent://' + window.location.hostname + window.location.pathname + '#Intent;scheme=https;package=com.android.chrome;end';
          } catch (err) {
            // Fallback
            window.location = currentUrl;
          }
        } else if (/iPhone|iPad|iPod/i.test(ua)) {
          // iOS - try Safari scheme
          try {
            window.location = 'safari-reader://' + window.location.href;
          } catch (err) {
            // Fallback - just try to open
            window.open(currentUrl, '_blank');
          }
        } else {
          window.open(currentUrl, '_blank');
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', showBlocker);
  } else {
    showBlocker();
  }
})();